<template>
  <FullScreenPanel
    v-if="fullScreen"
    :model-value="open"
    :title="title"
    :meta="meta"
    :test-id="testId"
    @update:model-value="onPanelToggle"
  >
    <template v-if="$slots['header-extra']" #header-extra>
      <slot name="header-extra" />
    </template>
    <template #default>
      <slot />
    </template>
    <template v-if="$slots.dock" #dock>
      <slot name="dock" />
    </template>
  </FullScreenPanel>

  <ModalVue v-else v-bind="$attrs" :modal-active="open" @close="emit('close')">
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <template #default>
      <slot />
    </template>
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </ModalVue>
</template>

<script setup lang="ts">
/**
 * "Casca" dos modais do dashboard (spec 2026-09-30 §5 R6): o `ModalVue` de sempre no
 * desktop ou o `FullScreenPanel` no celular, com o MESMO conteúdo. O consumidor não
 * duplica o template: `header`/`footer` só vão para o modal, `header-extra`/`dock`
 * só para o painel, e o corpo vai para os dois.
 *
 * `inheritAttrs: false` + `v-bind="$attrs"` no `ModalVue`: os atributos de hoje
 * (`hasHeaderBorder`, a classe `modal-pushed-by-sidebar`, `min-height`) continuam
 * chegando ao modal, e nunca ao painel.
 */
import FullScreenPanel from '@/components/designSystem/FullScreenPanel/FullScreenPanel.vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'

defineOptions({ name: 'DashboardModalShell', inheritAttrs: false })

withDefaults(
  defineProps<{
    open: boolean
    fullScreen: boolean
    title: string
    meta?: string
    testId?: string
  }>(),
  { meta: undefined, testId: 'full-screen-panel' }
)

const emit = defineEmits<{ close: [] }>()

// O painel só emite `false` ("←" ou Esc); abrir é sempre decisão do consumidor.
function onPanelToggle(value: boolean) {
  if (!value) emit('close')
}
</script>
